import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";

const firebaseConfig = {

  apiKey: "AIzaSyC-COsFkwpcRNZPX_RspIvTVab-SiQsKVk",

  authDomain: "portfolio-1af25.firebaseapp.com",

  projectId: "portfolio-1af25",

  storageBucket: "portfolio-1af25.appspot.com",

  messagingSenderId: "736817993189",

  appId: "1:736817993189:web:708075153025d13e62cb0c",

  measurementId: "G-GZXDG3XPPS"

};


const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);